import { FileIcon, FileTextIcon, FolderIcon } from "lucide-react";
import { memo } from "react";

import { cn } from "~/lib/utils";
import { basenameOfPath } from "../../pathEntry";

const DOCUMENT_EXTENSIONS = new Set(["doc", "docx", "md", "odt", "pdf", "rtf", "txt"]);

function isDocumentPath(pathValue: string): boolean {
  const basename = basenameOfPath(pathValue);
  const dotIndex = basename.lastIndexOf(".");
  return dotIndex > 0 && DOCUMENT_EXTENSIONS.has(basename.slice(dotIndex + 1).toLowerCase());
}

export const PathEntryIcon = memo(function PathEntryIcon(props: {
  pathValue: string;
  kind: "file" | "directory";
  className?: string;
}) {
  const Icon =
    props.kind === "directory"
      ? FolderIcon
      : isDocumentPath(props.pathValue)
        ? FileTextIcon
        : FileIcon;
  return (
    <Icon
      aria-hidden="true"
      className={cn("size-4 shrink-0 text-muted-foreground/80", props.className)}
    />
  );
});
